// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".align-content[data-v-964a768c]{height:50vh;margin:0}", ""]);
// Exports
module.exports = exports;
